/**
 * Sentry Context Hook
 * 
 * Updates Sentry user and route context when they change.
 * Should be used in the main App component.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppContext } from '../store/AppContext';
import { setSentryUser, setSentryRoute } from '../utils/sentry';

/**
 * Hook to keep Sentry context updated with current user and route
 */
export function useSentryContext(): void {
  const location = useLocation();
  const { user } = useAppContext();

  // Update user context when user changes
  useEffect(() => {
    setSentryUser(user?.uid || null);
  }, [user?.uid]);

  // Update route context when route changes
  useEffect(() => {
    setSentryRoute(location.pathname);
  }, [location.pathname]);
}
